/* Copyright (c) 2026 Hyegro Pty Ltd. All rights reserved. */

import colors from 'styles/tokens/colors';

/**
 * Paper styles for a right-hand detail drawer.
 *
 * The theme styles every MuiDrawer as the navy sidenav (assets/theme/components/
 * sidenav.js), so a plain <Drawer> renders dark text on #0E2348 and is
 * unreadable. Detail drawers need the light surface the rest of the page uses.
 */
export const drawerPaperSx = (width) => ({
  width,
  p: 0,
  backgroundColor: colors.background.white,
  color: colors.text.dark,
  border: `1px solid ${colors.border.default}`,
  boxShadow: '-4px 0 20px rgba(14, 35, 72, 0.12)',
  overflowX: 'hidden',
});
